export interface IIneligibleLender {
  id: string;
  numericId: number;
  name: string;
  code: string;
  reason: string;
  isManualExclude: boolean;
  manualExcludeDateTime: string;
}

export class IneligibleLenderModel implements Partial<IIneligibleLender> {
	id?: string;
	numericId?: number;
	name?: string;
	code?: string;
	reason?: string;
	isManualExclude?: boolean;
	manualExcludeDateTime?: string;

	constructor(data?: IIneligibleLender) {
		if (data) {
			this.id = data?.id;
			this.numericId = data?.numericId;
			this.name = data?.name;
			this.code = data?.code;
			this.reason = data?.reason;
			this.isManualExclude = data.isManualExclude;
			this.manualExcludeDateTime = data.manualExcludeDateTime;
		}
	}
}
